<template>
	<div class="modal-body">
		<div class="h4">Tell us more</div>

		<div
			v-if="view === 'membershipOptions'"
			class="d-grid gap-2 mt-3"
			data-testid="view-membership-options"
		>
			<button
				type="button"
				class="btn btn-actuator"
				data-testid="option-existing-member"
				@click="handleMembershipChoice('existingMember')"
			>
				Existing Life Time Member
			</button>
			<button
				type="button"
				class="btn btn-actuator"
				data-testid="option-become-member"
				@click="handleMembershipChoice('becomeMember')"
			>
				Become A Member
			</button>
		</div>

		<div v-else-if="view === 'existingMember'" data-testid="view-existing-member">
			<p>
				It is after hours for our Concierge Team, but you can visit the Life Time mobile app for
				assistance.
			</p>
			<a
				class="btn btn-actuator w-100"
				href="https://my.lifetime.life/lp/app-download.html?experience=membersupport"
				target="_blank"
				rel="noopener noreferrer"
			>
				Visit the Member Support Page
			</a>
		</div>
	</div>

	<div class="modal-footer">
		<div class="d-flex justify-content-between w-100">
			<button
				type="button"
				class="btn btn-simple btn-sm btn-icon"
				data-testid="button-back"
				@click="goBack"
			>
				<svg class="ki" width="24" height="24" fill="currentColor">
					<use
						href="/etc/designs/ltnext/lt-kumiko-components/icons/kumiko-icons.svg#arrow-left-parens"
					></use>
				</svg>
				Back
			</button>
		</div>
	</div>
</template>
<script setup lang="ts">
import { ref, computed, type ComputedRef } from 'vue';

type ViewState = 'membershipOptions' | 'existingMember';
type MembershipChoice = 'existingMember' | 'becomeMember';
type BackState = 'membershipOptions' | 'form';

const view = ref<ViewState>('membershipOptions');

const backState: ComputedRef<BackState> = computed(() => {
	switch (view.value) {
		case 'membershipOptions':
			return 'form';
		case 'existingMember':
		default:
			return 'membershipOptions';
	}
});

const emit = defineEmits<{
	(e: 'step-change', step: 'form' | 'chat'): void;
}>();

const goBack = () => {
	if (backState.value === 'form') {
		emit('step-change', 'form');
		return;
	}

	view.value = backState.value;
};

const handleMembershipChoice = (choice: MembershipChoice) => {
	if (choice === 'becomeMember') {
		emit('step-change', 'chat');
		return;
	}

	view.value = choice;
};
</script>

<style lang="scss" scoped>
.modal-body {
	.btn.btn-actuator {
		padding: 1rem 1.75rem;
		line-height: 1.25rem;
	}
}
</style>
